import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=998be2b6&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('998be2b6')) {
      api.createRecord('998be2b6', component.options)
    } else {
      api.reload('998be2b6', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=998be2b6&", function () {
      api.rerender('998be2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/Dashboard.vue"
export default component.exports